<template>
  <div class="parent">
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: false,
    };
  },

  methods: {
  },

  created: async function () {
    
  },
};
</script>

<style scoped>
</style>